module.exports = function($) {

    /**
     *
     * @param params
     */
    function forms(params) {
        let $form = $(params.form);
        let action = params.action;
        let f = {
            onChange: function () {
                $('input, textarea, select').on('change', function () {
                    $(this).removeClass('is-invalid');
                })
            },
            submit: function () {
                $form.on('submit', function (e) {
                    e.preventDefault();
                    let $this = $(this);
                    let formData = new FormData(this);
                    formData.append('action', action);
                    $this.find('.alert').remove();
                    $this.find('[type="submit"]').css({'display': 'none'});
                    $this.append('<div class="loading"></div>');
                    $.ajax({
                        type: "POST",
                        url: WP.ajaxurl,
                        data: formData,
                        processData: false,
                        contentType: false,
                        success: function (data) {
                            $this.find('.alert').remove();
                            $this.find('.loading').remove();
                            grecaptcha.reset();
                            if (data.status == 400) {
                                $this.find('.message').html('<div class="alert alert-danger">' + data.message + '</div>');
                                for (const f in data.fields) {
                                    $this.find('[name="' + data.fields[f] + '"]').addClass('is-invalid');
                                }
                                $this.find('[type="submit"]').css({'display': 'flex'});
                            }
                            if (data.status == 200) {
                                $this.get(0).reset();
                                $this.find('.message').html('<div class="alert alert-success">' + data.message + '</div>');
                                $this.find('.type-file').text();
                                $this.find('[type="submit"]').css({'display': 'none'});
                            }
                        },
                        error: function (e) {
                            $this.find('.loading').remove();
                            $this.find('.message').html('<div class="alert alert-danger">404 Bad request</div>');
                            $this.find('[type="submit"]').css({'display': 'flex'});
                        }
                    });
                });
            }
        }

        f.submit();
        f.onChange();
    }

    new forms({
        form: '.block.contact form',
        action: 'contact_form'
    });

}
